<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent width="800px">
      <v-card>
        <v-card-title class="blue darken-4 white--text">
          <span class="text-center headline"> {{ input.id ? 'Actualizar Agrupador' : 'Registrar Agrupador' }} </span>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-8">
            <v-col cols="12" sm="6">
              <v-text-field v-model.trim="input.nombre" dense label="Nombre:" hide-details outlined></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model.number="input.orden"
                type="number"
                dense
                label="Orden:"
                hide-details
                outlined></v-text-field>
            </v-col>
          </v-row>
          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" rounded outlined @click="validar()">
            <v-icon class="mx-1">mdi-content-save</v-icon> {{ input.id ? 'Actualizar' : 'Registrar' }}
          </v-btn>
          <v-btn rounded outlined @click="dialog = !dialog"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
  .end-input >>> input {
    text-align: end;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        input: {
          id: 2,
          nombre: 'test prueba modificado',
          orden: 3,
        },
      };
    },
    components: {},
    computed: {},
    watch: {},
    methods: {
      openmodal(item = {}) {
        this.msg = '';
        this.input.id = item.id;
        this.input.nombre = item.nombre;
        this.input.orden = item.orden;
        this.dialog = true;
      },

      validar() {
        this.msg = '';
        let vue = this;
        if (!this.input.nombre) this.msg = 'Ingrese el nombre.';
        if (this.input.orden < 0) this.msg = 'Orden mayor a cero.';
        if (this.msg) return;
        this.loading = true;

        let m = 'post';
        if (this.input.id) m = 'put';
        var config = {
          method: m,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/agrupadores`,
          headers: {},
          data: this.input,
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            window.console.log(response, data);
            vue.$emit('onnew', data);
            vue.dialog = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.dialog = false;
          });
      },
    },
  };
</script>
